export const createEchoSocketHeaderInterceptor = (echoService) => (config) => {
    if (echoService.socketId()) {
        config.headers['X-Socket-Id'] = echoService.socketId();
    }

    return config;
};
